import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { SeoHead } from "@/components/SeoHead";
import { absoluteSeoUrl, limitSeoText } from "@/lib/seo";

const BrandPage = () => {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setB(null);
    setErr(null);
    api.get(`/brands/${slug}`)
      .then((response) => setB(response.data))
      .catch(() => setErr("Brand not found"));
  }, [slug]);

  if (err) {
    return (
      <div className="py-20 text-center text-[#64748B]">
        {err}. <Link to="/" className="text-[#C86D42]">Home →</Link>
      </div>
    );
  }
  if (!b) {
    return <div className="py-20 text-center">Loading…</div>;
  }

  const seo = {
    title: `${b.name} Collection | Eira Products`,
    description: limitSeoText(
      b.description || `Explore the ${b.name} collection at Eira Products.`,
    ),
    canonical: absoluteSeoUrl(`/brand/${b.slug || slug}`),
    image: b.image || "",
    type: "website",
  };
  return (
    <>
      <SeoHead seo={seo} />
      <div data-testid="brand-page">
        <section
          className="relative min-h-[400px] overflow-hidden"
          style={{ background: b.accent_color || "#2D5A47" }}
        >
          {b.image && (
            <img
              src={b.image}
              alt=""
              loading="lazy"
              decoding="async"
              className="absolute inset-0 h-full w-full object-cover opacity-40"
            />
          )}
          <div
            className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"
          />
          <div
            className="relative mx-auto max-w-7xl px-4 py-16 text-white sm:px-8 lg:px-12 lg:py-24"
          >
            <div className="mb-4 text-xs uppercase tracking-[0.3em] text-[#D99B26]">
              An Eira Brand
            </div>
            <h1 className="font-serif text-5xl font-semibold lg:text-7xl">{b.name}</h1>
            {b.tagline && (
              <p className="mt-4 max-w-2xl text-xl text-white/80">{b.tagline}</p>
            )}
            {b.description && (
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-white/70">
                {b.description}
              </p>
            )}
          </div>
        </section>
        <section className="mx-auto max-w-7xl px-4 py-12 sm:px-8 lg:px-12">
          <div className="mb-6 flex items-end justify-between">
            <h2 className="font-serif text-3xl font-semibold">The {b.name} Collection</h2>
            <span className="text-sm text-[#64748B]">{b.products?.length || 0} products</span>
          </div>
          {b.products?.length > 0 ? (
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-6">
              {b.products.map((product) => <ProductCard key={product.id} product={product} />)}
            </div>
          ) : (
            <div className="py-16 text-center text-[#64748B]">
              Products coming soon for this brand.
            </div>
          )}
        </section>
      </div>
    </>
  );
};

export default BrandPage;
